import { createContext } from 'react';

export const ROOT_ACTION = createContext();
